import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const EventInfoPosition = styled.div<IWithSize>`
  display: flex;
  align-items: center;
  height: ${({ size }) => (size ? 38 * size : 38)}px;
`

export default EventInfoPosition
